import React from "react";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import Header from "../../../components/Header/Header";

const Calculator = () => {
  return (
    <BodyWrapper>
      <Header
        title="Calculator"
        desc="Perform calculations and manage your financial data"
      ></Header>
    </BodyWrapper>
  );
};

export default Calculator;
